module.exports = __webpack_public_path__ + "assets/img/resonance-logo-text.9bf64cf3.svg";